<template>
  <div class="biglietti-mobile" v-loading="loading">
    <div v-show="showPrincipal">
      <div class="row row-custom biglietti-header">
        <div class="col-14 titolo no-padding">
          <span>{{ $t('biglietti.label.title') }}</span>
        </div>
        <div class="col-10 action no-padding">
          <div class="add" v-if="enableAction('add')" @click="add">
            <icon name="riv-add_2" scale="2" class="pointer"></icon>
          </div>
        </div>
      </div>

      <el-table :data="biglietti" @row-click="open" :empty-text="$t('biglietti.msg.noData')" class="el-table_mobile">

        <el-table-column header-align="center" align="center" width="30">


          <template slot-scope="scope" slot="header">
            <div class="icon-title" :key="scope.length">
              <el-popover placement="top" v-model="visibleInfo">
                <div>
                  <div>
                    <icon name="riv-circle" class="status-saved" scale="0.8"></icon>
                    <span>{{ $t('statusDett.0') }}</span>
                  </div>
                  <div>
                    <icon name="riv-circle" class="status-send" scale="0.8"></icon>
                    <span>{{ $t('statusDett.1') }}</span>
                  </div>
                  <div>
                    <icon name="riv-circle" class="status-rejected" scale="0.8"></icon>
                    <span>{{ $t('statusDett.2') }}</span>
                  </div>
                  <div>
                    <icon name="riv-circle" class="status-approved" scale="0.8"></icon>
                    <span>{{ $t('statusDett.3') }}</span>
                  </div>
                </div>

                <span slot="reference">
                  <icon class="pointer" name="riv-help" scale="1"></icon>
                </span>
              </el-popover>

            </div>
          </template>


          <template slot-scope="scope">
            <div class="data-wrapper">
              <el-tooltip class="item" effect="dark" :content="$t('statusDett.' + scope.row.statoAvanz)"
                placement="top-start">
                <icon :name="getStatoIcon_dett(scope.row.statoAvanz)" :class="getStatoClass_dett(scope.row.statoAvanz)"
                  scale="0.8"></icon>
              </el-tooltip>
            </div>
          </template>

        </el-table-column>
        <el-table-column header-align="center" align="center" :label="$t('biglietti.label.giorno')" width="100"
          class-name="sfondino">

          <template slot-scope="scope">
            <div class="name-wrapper">
              <span class="block">{{ scope.row.giorno | formattaData }}</span>
              <span class="block"> {{ scope.row.oraPart | formattaHours }} / {{ scope.row.oraArr | formattaHours
                }}</span>
            </div>
          </template>

        </el-table-column>

        <el-table-column header-align="center" align="center" :label="$t('biglietti.label.tratta')" class-name="">

          <template slot-scope="scope">
            <div class="name-wrapper">
              <span class="block truncate">{{ scope.row.partenza }}</span>
              <span class="block truncate"> {{ scope.row.destinazione }}</span>
            </div>
          </template>

        </el-table-column>

        <el-table-column header-align="center" align="center" width="50">

          <template slot-scope="scope" slot="header">
            <el-tooltip class="item" effect="dark" :content="$t('biglietti.label.navetta')" placement="top-start"
              :key="scope.length">
              <icon name="riv-taxi" scale="1.2"></icon>
            </el-tooltip>
          </template>

          <template slot-scope="scope">
            <div class="data-wrapper">
              {{ desNanetta(scope.row) }}
            </div>
          </template>
        </el-table-column>

        <el-table-column header-align="center" align="center" width="30">

          <template slot-scope="scope">
            <div class="name-wrapper" :key="scope.length" @click.stop.prevent v-if="enableAction('del')">
              <el-tooltip placement="left" popper-class="popover-mobile" effect="light">
                <template slot="content">
                  <div @click="del(scope.row)" v-if="enableAction('del')">
                    <span>{{ $t('biglietti.label.delete') }}</span>
                  </div>
                </template>

                <icon class="pointer action" name="riv-more" scale="1.5"></icon>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination v-if="(nrPages > 1)" :current-page="currentPage" background layout="prev, pager, next"
        :total="nrItems" :page-size="pag_for" @current-change="changePage">
      </el-pagination>
    </div>
    <!-- Dialog di creazione di una nuova richiesta di ferie -->
    <div v-show="showModal" class="el-form_mobile">

      <div class="el-form-header row row-custom">
        <div class="el-form-action col-2 no-padding">
          <icon name="riv-arrow2" scale="1.2" flip="horizontal" @click.native="closeModal('showModal')"></icon>
        </div>
        <div class="el-form-title col-20 no-padding">
          {{ $t('biglietti.label.title').toUpperCase() }}
        </div>
      </div>

      <el-form class="el-form-body" :disabled="formDisabled">
        <div class="elemento row row-custom"
          :class="[!this.validaBiglietto && (this.form.giorno === undefined || this.form.giorno === '') ? 'row-error' : '']">
          <div class="el-form-label col-24 no-padding">{{ $t('biglietti.label.giorno') + ' (*)' }}</div>
          <div class="el-form-input col-24 no-padding">
            <div class="input-wrapper">
              <input type="date" v-model="form.giorno" class="first" :disabled="formDisabled"
                :class="formDisabled ? 'field-disabled' : ''" />
            </div>
          </div>
        </div>

        <div class="elemento row row-custom"
          :class="[!this.validaBiglietto && (this.form.mezzo === undefined || this.form.mezzo === '') ? 'row-error' : '']">
          <div class="el-form-label col-24 no-padding">{{ $t('biglietti.label.mezzoTrasp') + ' (*)' }}</div>
          <div class="el-form-input col-24 no-padding">
            <div class="select-wrapper">
              <select v-model="form.mezzo" :disabled="formDisabled" :class="formDisabled ? 'field-disabled' : ''">
                <option v-for="(item) in tbl_mezzi" :value="item.id" :key="item.id">{{ item.desc }}</option>
              </select>
            </div>
          </div>
        </div>

        <div class="elemento row row-custom"
          :class="[!this.validaBiglietto && (this.form.partenza === undefined || this.form.partenza === '') ? 'row-error' : '']">
          <div class="el-form-label col-24 no-padding">{{ $t('biglietti.label.partenza') + ' (*)' }}</div>
          <div class="el-form-input col-24 no-padding">
            <div class="input-wrapper">
              <input v-model="form.partenza" class="first" :disabled="formDisabled"
                :class="formDisabled ? 'field-disabled' : ''" />
            </div>
          </div>
        </div>

        <div class="elemento row row-custom"
          :class="[!this.validaBiglietto && (this.form.oraPart === undefined || this.form.oraPart === null) ? 'row-error' : '']">
          <div class="el-form-label col-24 no-padding">{{ $t('biglietti.label.orarioPart') + ' (*)' }}</div>
          <div class="el-form-input col-24 no-padding">
            <div class="input-wrapper">
              <input type="time" v-model="form.oraPart" class="first" :disabled="formDisabled"
                :class="formDisabled ? 'field-disabled' : ''" />
            </div>
          </div>
        </div>

        <div class="elemento row row-custom"
          :class="[!this.validaBiglietto && (this.form.destinazione === undefined || this.form.destinazione === '') ? 'row-error' : '']">
          <div class="el-form-label col-24 no-padding">{{ $t('biglietti.label.destinazione') + ' (*)' }}</div>
          <div class="el-form-input col-24 no-padding">
            <div class="input-wrapper">
              <input v-model="form.destinazione" class="first" :disabled="formDisabled"
                :class="formDisabled ? 'field-disabled' : ''" />
            </div>
          </div>
        </div>

        <div class="elemento row row-custom"
          :class="[!this.validaBiglietto && (this.form.oraArr === undefined || this.form.oraArr === null) ? 'row-error' : '']">
          <div class="el-form-label col-24 no-padding">{{ $t('biglietti.label.orarioArrivo') + ' (*)' }}</div>
          <div class="el-form-input col-24 no-padding">
            <div class="input-wrapper">
              <input type="time" v-model="form.oraArr" class="first" :disabled="formDisabled"
                :class="formDisabled ? 'field-disabled' : ''" />
            </div>
          </div>
        </div>

        <div class="elemento row row-custom">
          <div class="el-form-label col-24 no-padding">{{ $t('biglietti.label.note') }}</div>
          <div class="el-form-input col-24 no-padding" style="height: 100%;">
            <div class="input-wrapper">
              <textarea v-model="form.notaDip" class="first" rows="5" :disabled="formDisabled"
                :class="formDisabled ? 'field-disabled' : ''" />
            </div>
          </div>
        </div>

        <div class="elemento row row-custom">
          <div class="my-area col-24 no-padding">
            {{ $t('biglietti.label.navetta') }}
          </div>


          <div class="elemento row row-custom">
            <div class="el-form-label col-22 no-padding">
              {{ $t('biglietti.label.navettaDa', { partenza: form.partenza }) }}
            </div>
            <div class="el-form-label col-2 no-padding">
              <el-checkbox v-model="form.checkedNavettaFrom" :indeterminate="false"></el-checkbox>
            </div>
            <div class="el-form-input col-24 no-padding">
              <div class="input-wrapper">
                <input v-model="form.navettaPart" class="first" :placeholder="[$t('biglietti.label.luogo')]"
                  :disabled="formDisabled || !form.checkedNavettaFrom" :class="formDisabled ? 'field-disabled' : ''" />
              </div>
            </div>
            <div class="el-form-input col-24 no-padding">
              <div class="input-wrapper">
                <input type="time" v-model="form.navettaOraPart" class="first"
                  :placeholder="[$t('biglietti.label.orario')]" :disabled="formDisabled || !form.checkedNavettaFrom"
                  :class="formDisabled ? 'field-disabled' : ''" />
              </div>
            </div>
          </div>

          <div class="elemento row row-custom">
            <div class="el-form-label col-22 no-padding">
              {{ $t('biglietti.label.navettaPer', { destinazione: form.destinazione }) }}
            </div>
            <div class="el-form-label col-2 no-padding">
              <el-checkbox v-model="form.checkedNavettaTo" :indeterminate="false"></el-checkbox>
            </div>
            <div class="el-form-input col-24 no-padding">
              <div class="input-wrapper">
                <input v-model="form.navettaDest" class="first" :placeholder="[$t('biglietti.label.luogo')]"
                  :disabled="formDisabled || !form.checkedNavettaTo" :class="formDisabled ? 'field-disabled' : ''" />
              </div>
            </div>
          </div>

        </div>

        <div v-if="form.statoAvanz !== '0'">
          <div class="elemento row row-custom">
            <div class="my-area col-24 no-padding">
              {{ $t('biglietti.label.segreteria') }}
            </div>
          </div>
          <div class="elemento row row-custom" v-if="form.notaSeg !== ''">
            <div class="my-label col-8 no-padding">
              {{ $t('biglietti.label.noteSegreteria') }}
            </div>
            <div class="my-value col-16 no-padding">
              {{ form.notaSeg }}
            </div>
          </div>
          <div class="elemento row row-custom">
            <div v-if="form.nomeFile !== ''" class="col-24 no-padding">
              <div @click="getDoc(form.nomeFile)">
                <icon name="riv-download" scale="1.5"></icon>
                <span class="truncate applicazione">{{ form.nomeFile }}</span>
              </div>
            </div>
          </div>
        </div>


      </el-form>

      <span slot="footer" class="">
        <el-button class="mobile-el-button primary" v-if="!formDisabled" @click="checkSave()">{{ $t('btn.salva')
          }}</el-button>
        <el-button class="mobile-el-button secondary" v-if="formDisabled" @click="closeModal('showModal')">{{
          $t('btn.close') }}</el-button>
        <el-button class="mobile-el-button secondary" v-if="!formDisabled" @click="closeModal('showModal')">{{
          $t('btn.annulla') }}</el-button>
      </span>

    </div>
    <!--</el-dialog>-->

  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'BigliettiMobile',
  props: ['trasferta'],
  i18n: {
    messages: {
      it_IT: {
        biglietti: {
          label: {
            title: 'Biglietto',
            status: 'Stato',
            giorno: 'Giorno',
            mezzoTrasp: 'Mezzo di Trasporto',
            partenza: 'Partenza',
            destinazione: 'Destinazione',
            tratta: 'Tratta',
            orarioPart: 'Ora di Partenza',
            orarioArrivo: 'Ora di Arrivo',
            orario: 'Orario',
            note: 'Nota',
            navetta: 'Trasporti',
            navettaDa: 'Si richiede il Trasporto per {partenza} da?',
            navettaPer: 'Si richiede il Trasporto da {destinazione} per?',
            segreteria: 'Segreteria',
            noteSegreteria: 'Note Segreteria',
            allegati: 'Allegati',
            luogo: 'Luogo',
            delete: 'Elimina',
          },
          msg: {
            saveTransportFrom: 'Salvataggio Trasporto Andata',
            saveTransportTo: 'Salvataggio Trasporto Ritorno',
            noData: 'Nessun Biglietto Trovato',
            datiObbligatoriMancanti: 'Dati obbligatori mancanti'
          }
        }
      },
      fr_FR: {
        biglietti: {
          label: {
            title: 'Réserver Billets Voyage',
            status: 'Etat',
            giorno: 'Jour',
            mezzoTrasp: 'Véhicule',
            partenza: 'Départ',
            destinazione: 'Destination',
            tratta: 'Route',
            orarioPart: 'heure de départ',
            orarioArrivo: 'heure de arrivé',
            orario: 'Horaire',
            note: 'Notes',
            navetta: 'Transport',
            navettaDa: 'Avez-vous besoin de transport pour {partenza} à partir de?',
            navettaPer: 'Avez-vous besoin d\'un moyen de transport de {destinazione} pour?',
            segreteria: 'Secrétaire',
            noteSegreteria: 'Annotations de la Secrétaire',
            allegati: 'Annexes',
            luogo: 'Endroit',
            delete: 'Supprimer',
          },
          msg: {
            saveTransportFrom: 'Sauvetage Transport Aller',
            saveTransportTo: 'Sauvetage Transport Retour',
            noData: 'Aucun Billet trouvé',
            datiObbligatoriMancanti: 'Données obligatoires manquantes'
          }
        }
      },
      es_ES: {
        biglietti: {
          label: {
            title: 'Ticket',
            status: 'Estado',
            giorno: 'Día',
            mezzoTrasp: 'Transporte',
            partenza: 'Salida',
            destinazione: 'Destino',
            tratta: 'Ruta',
            orarioPart: 'Hora de salida',
            orarioArrivo: 'Hora de llegada',
            orario: 'Horas',
            note: 'Nota',
            navetta: 'Transporte',
            navettaDa: 'Necesario transporte hasta {partenza} desde',
            navettaPer: 'Necesario transporte desde {destinazione} hasta',
            segreteria: 'Secretaria',
            noteSegreteria: 'Nota de la Secretaria',
            allegati: 'Adjuntos',
            luogo: 'Lugar',
            delete: 'Borrar'
          },
          msg: {
            saveTransportFrom: 'Viaje de ida guardado',
            saveTransportTo: 'Viaje de vuelta guardado',
            noData: 'Sin informacion',
            datiObbligatoriMancanti: 'Faltan datos obligatorios'
          }
        }
      },
      de_DE: {
        biglietti: {
          label: {
            title: 'Ticket',
            status: 'Land',
            giorno: 'Tag',
            mezzoTrasp: 'Transport',
            partenza: 'Abreiseort',
            destinazione: 'Reiseziel',
            tratta: 'Route',
            orarioPart: 'Abfahrtszeit',
            orarioArrivo: 'Ankunftszeit',
            orario: 'Zeitraum',
            note: 'Notiz',
            navetta: 'Transport',
            navettaDa: 'Transport bis {partenza} ab?',
            navettaPer: 'Transport ab {destinazione} bis?',
            segreteria: 'Sekretariat',
            noteSegreteria: 'Notiz des Sekretariat',
            allegati: 'Anlage',
            luogo: 'Platz',
            delete: 'Stornieren',
          },
          msg: {
            saveTransportFrom: 'Transport nach außen retten',
            saveTransportTo: 'Rücktransport retten',
            noData: 'Keine Tickets gefunden',
            datiObbligatoriMancanti: 'Fehlende Pflichtangaben'
          }
        }
      },
      en_GB: {
        biglietti: {}
      }
    }
  },
  data() {
    return {
      showPrincipal: true,
      visibleInfo: false,
      loading: false,
      biglietti: [],
      currentPage: 1,
      pag_for: 8,
      pag_order: 'DD',
      nrPages: 0,
      nrItems: 0,
      showModal: false,
      form: {},
      tbl_mezzi: [],
      formDisabled: false,
      validaBiglietto: true,
      validaNavettaFrom: true,
      validaNavettaTo: true,
    }
  },
  filters: {
    /* Formatta la data: GGMMAAAA --> GG/MM/AAAA */
    formattaData: function (date) {
      if (date !== '') {
        return date.substr(6, 2) + '/' + date.substr(4, 2) + '/' + date.substr(0, 4)
      } else {
        return ' '
      }
    },
    formattaHours: function (hours) {
      if (hours !== '') {
        return hours.replace(',', ':')
      } else {
        return ' '
      }
    }
  },
  beforeMount: function () {
    this.formDisabled = this.trasferta.terminata === 'T' ? true : false
    this.loading = true
    this.loadMezzi()
    this.loadBiglietti()
  },
  mounted: function () {
  },
  methods: {
    loadBiglietti: function () {
      this.loading = true
      this.$set(this, 'biglietti', [])
      this.$http.get('trasferte/' + this.$store.state.country + '/biglietti', {
        params: {
          idTrasferta: this.trasferta.idTrasferta,
          pag_action: (this.currentPage > 1) ? 'NEXT' : 'BEGIN',
          pag_from: this.currentPage,
          pag_for: this.pag_for,
          pag_order: this.pag_order
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.biglietti = response.body.data
            if (this.currentPage === 1) {
              this.$set(this, 'nrPages', parseInt(response.body.attrib.pages))
              this.$set(this, 'nrItems', parseInt(response.body.attrib.size))
            }
          } else {
            if (response.body.msg[0].msgId !== '1218') {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
            this.$set(this, 'biglietti', [])
            this.$set(this, 'nrPages', 0)
            this.$set(this, 'nrItems', 0)
          }
          this.loading = false
        })
    },
    add: function () {
      this.validaBiglietto = true
      this.validaNavettaFrom = true
      this.validaNavettaTo = true
      this.$set(this, 'form', {})
      this.$set(this.form, 'giorno', moment(this.trasferta.dataDal, "YYYYMMDD").format("YYYY-MM-DD"))
      this.form.id = ''
      this.form.idTraspAnd = ''
      this.form.idTraspRit = ''
      this.form.idTrasferta = this.trasferta.idTrasferta
      this.form.statoAvanz = '0'
      this.openModal("showModal")
    },
    open: function (row, event, column) {
      this.validaBiglietto = true
      this.validaNavettaFrom = true
      this.validaNavettaTo = true
      this.$set(this, 'form', {})
      this.form.idTrasferta = row.idTrasferta
      this.form.id = row.id
      this.form.statoAvanz = row.statoAvanz
      this.$set(this.form, 'giorno', moment(row.giorno, "YYYYMMDD").format("YYYY-MM-DD"))
      this.$set(this.form, 'oraPart', moment(row.oraPart, 'HH,mm').format('HH:mm'))
      this.$set(this.form, 'oraArr', moment(row.oraArr, 'HH,mm').format('HH:mm'))
      this.$set(this.form, 'mezzo', row.mezzo)
      this.$set(this.form, 'partenza', row.partenza)
      this.$set(this.form, 'destinazione', row.destinazione)
      this.$set(this.form, 'notaDip', row.notaDip.split("\\n").join("\n"))
      if (row.idTraspAnd != undefined) {
        this.form.idTraspAnd = row.idTraspAnd
        this.$set(this.form, 'navettaPart', row.luogoPartTraspAnd)
        this.$set(this.form, 'navettaOraPart', moment(row.oraPartTraspAnd, 'HH,mm').format('HH:mm'))
        this.$set(this.form, 'checkedNavettaFrom', true)
      } else {
        this.form.idTraspAnd = ''
        this.$set(this.form, 'checkedNavettaFrom', false)
      }
      if (row.idTraspRit != undefined) {
        this.form.idTraspRit = row.idTraspRit
        this.$set(this.form, 'navettaDest', row.luogoArrTraspRit)
        this.$set(this.form, 'checkedNavettaTo', true)
      } else {
        this.form.idTraspRit = ''
        this.$set(this.form, 'checkedNavettaTo', false)
      }

      // Segreteria
      this.form.notaSeg = row.notaSeg
      this.form.nomeFile = row.nomeFile

      // Show Modal
      this.openModal("showModal")
    },
    checkSave: function () {
      this.validaBiglietto = true
      this.validaNavettaFrom = true
      this.validaNavettaTo = true
      if (this.form.giorno === '' || this.form.giorno === undefined) {
        this.validaBiglietto = false
      }
      if (this.form.mezzo === '' || this.form.mezzo === undefined) {
        this.validaBiglietto = false
      }
      if (this.form.partenza === '' || this.form.partenza === undefined) {
        this.validaBiglietto = false
      }
      if (this.form.oraPart === '' || this.form.oraPart === undefined) {
        this.validaBiglietto = false
      }
      if (this.form.destinazione === '' || this.form.destinazione === undefined) {
        this.validaBiglietto = false
      }
      if (this.form.oraArr === '' || this.form.oraArr === undefined) {
        this.validaBiglietto = false
      }

      // Verifico Dati Navette
      if (this.form.checkedNavettaFrom) {
        if (this.form.navettaPart === '' || this.form.navettaPart === undefined) {
          this.validaNavettaFrom = false
        }
        if (this.form.navettaOraPart === '' || this.form.navettaOraPart === undefined) {
          this.validaNavettaFrom = false
        }
      }
      if (this.form.checkedNavettaTo) {
        if (this.form.navettaDest === '' || this.form.navettaDest === undefined) {
          this.validaNavettaTo = false
        }
      }
      if (this.validaBiglietto && this.validaNavettaFrom && this.validaNavettaTo) {
        this.save()
      } else {
        this.$message.error(this.$i18n.t('biglietti.msg.datiObbligatoriMancanti'))
      }
    },
    save: function () {
      let _this = this
      this.loading = true

      let objTraspAnd = {
        'idTrasferta': this.form.idTrasferta,
        'id': this.form.idTraspAnd === '' ? '' : this.form.idTraspAnd,
        'giorno': moment(this.form.giorno, 'YYYY-MM-DD').format('YYYYMMDD'),
        'oraPart': moment(this.form.navettaOraPart, 'HH:mm').format('HH.mm.ss'),
        'partenza': this.form.navettaPart,
        'destinazione': this.form.partenza,
        'idBiglietto': this.form.id,
        'navetta': 'A'
      }

      let navettaAnd = false
      if (this.form.idTraspAnd === '' && this.form.checkedNavettaFrom) {
        objTraspAnd['operazione'] = '*ADD'
        objTraspAnd['statoAvanz'] = '0'
        navettaAnd = true
      } else if (this.form.id != '' && this.form.idTraspAnd != '' && !this.form.checkedNavettaFrom) {
        objTraspAnd['operazione'] = '*DEL'
        navettaAnd = true
      } else if (this.form.id != '' && this.form.idTraspAnd != '' && this.form.checkedNavettaFrom) {
        objTraspAnd['operazione'] = '*UPD'
        navettaAnd = true
      }

      let objTraspRit = {
        'idTrasferta': this.form.idTrasferta,
        'id': this.form.idTraspRit === '' ? '' : this.form.idTraspRit,
        'giorno': moment(this.form.giorno, 'YYYY-MM-DD').format('YYYYMMDD'),
        'oraPart': moment(this.form.oraArr, 'HH:mm').format('HH.mm.ss'),
        'partenza': this.form.destinazione,
        'destinazione': this.form.navettaDest,
        'idBiglietto': this.form.id,
        'navetta': 'R'
      }

      let navettaRit = false
      if (this.form.idTraspRit === '' && this.form.checkedNavettaTo) {
        objTraspRit['operazione'] = '*ADD'
        objTraspRit['statoAvanz'] = '0'
        navettaRit = true
      } else if (this.form.id != '' && this.form.idTraspRit != '' && !this.form.checkedNavettaTo) {
        objTraspRit['operazione'] = '*DEL'
        navettaRit = true
      } else if (this.form.id != '' && this.form.idTraspRit != '' && this.form.checkedNavettaTo) {
        objTraspRit['operazione'] = '*UPD'
        navettaRit = true
      }

      let obj = {
        'idTrasferta': this.form.idTrasferta,
        'id': this.form.id === '' ? '' : this.form.id,
        'statoAvanz': this.form.statoAvanz,
        'operazione': this.form.id === '' ? '*ADD' : '*UPD',
        'giorno': moment(this.form.giorno, 'YYYY-MM-DD').format('YYYYMMDD'),
        'oraPart': moment(this.form.oraPart, 'HH:mm').format('HH.mm.ss'),
        'oraArr': moment(this.form.oraArr, 'HH:mm').format('HH.mm.ss'),
        'partenza': this.form.partenza,
        'destinazione': this.form.destinazione,
        'mezzo': this.form.mezzo,
        'notaDip': this.form.notaDip,
        'navettaAndata': objTraspAnd,
        'navettaRitorno': objTraspRit
      }

      if (!navettaAnd) {
        delete obj['navettaAndata']
      }
      if (!navettaRit) {
        delete obj['navettaRitorno']
      }

      this.$http.post('trasferte/' + this.$store.state.country + '/biglietto', obj)
        .then(response => {
          if (response.body.rc === 0) {
            this.$message({
              showClose: true,
              message: response.body.respBiglietto.msg[0].msgTxt,
              type: 'success',
              duration: process.env.duration
            })

            if (response.body.respNavettaAndata != undefined) {
              setTimeout(function () {
                // Notifico l'azione di salvataggio Alloggio
                //Notifico il salvataggio del giorno
                _this.$notify({
                  title: _this.$i18n.t('biglietti.msg.saveTransportFrom'),
                  message: response.body.respNavettaAndata.msg[0].msgTxt,
                  type: response.body.respNavettaAndata.rc === 0 ? 'success' : 'error',
                  duration: process.env.duration
                })
              }, 400)
            }

            if (response.body.respNavettaRitorno != undefined) {
              setTimeout(function () {
                // Notifico l'azione di salvataggio Alloggio
                //Notifico il salvataggio del giorno
                _this.$notify({
                  title: _this.$i18n.t('biglietti.msg.saveTransportTo'),
                  message: response.body.respNavettaRitorno.msg[0].msgTxt,
                  type: response.body.respNavettaRitorno.rc === 0 ? 'success' : 'error',
                  duration: process.env.duration
                })
              }, 800)
            }
            this.loadBiglietti()
            this.closeModal("showModal")
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.loading = false
        })
    },
    del: function (row) {
      this.loading = true
      this.$http.delete('trasferte/' + this.$store.state.country + '/biglietto/' + row.idTrasferta + '/' + row.id)
        .then(response => {
          if (response.body.rc === 0) {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'success',
              duration: process.env.duration
            })
            this.loadBiglietti()
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.loading = false
        })
    },
    changePage: function (page) {
      this.currentPage = page
      this.loadBiglietti()
    },
    loadMezzi: function (value) {
      this.$http.get('trasferte/' + this.$store.state.country + '/filtri', {
        params: {
          id: 'mezziBiglietto'
        }
      }).then(response => {
        if (response.body.rc === 0) {
          this.tbl_mezzi = response.body.data
          this.tbl_mezzi.unshift({ id: '', desc: ' ' })
        } else {
          this.$message({
            showClose: true,
            message: response.body.msg[0].msgTxt,
            type: 'error',
            duration: process.env.duration
          })
        }
      })
    },
    getDoc: function (nomeFile) {
      //let url = ('download/trasferta?fileName=' + nomeFile + '&country=' + this.$store.state.country + '&token=' + sessionStorage.getItem('token'))
      let url = ('download/document?codLang=' + sessionStorage.getItem('codLang') + '&delete=NO' +
        '&fileName=' + nomeFile + '&filePath=PaiCEDEXP' + '&token=' + sessionStorage.getItem('token'))
      let win = window.open(process.env.baseUrlSpring + url, '_blank')
      win.focus()
    },
    isDisabled: function () {
      if (this.trasferta.terminata === 'T' || this.form.id != '') {
        return true
      } else {
        return false
      }
    },
    desNanetta: function (row) {
      if (row.idTraspAnd !== undefined && row.idTraspAnd !== '' && row.idTraspRit !== undefined && row.idTraspRit !== '') {
        return 'A/R'
      } else if (row.idTraspAnd !== undefined && row.idTraspAnd != '') {
        return 'A'
      } else if (row.idTraspRit !== undefined && row.idTraspRit != '') {
        return 'R'
      } else {
        return ''
      }
    },
    enableAction: function (action, row) {
      let statoTrasferta = this.trasferta.statoAvanz
      if (this.trasferta.terminata === 'T') {
        return false
      }
      switch (action) {
        case 'del':
          if (statoTrasferta === '0' || statoTrasferta === '1' || statoTrasferta === '3' || statoTrasferta === '4' || statoTrasferta === '5') {
            return true
          } else {
            return false
          }
        case 'add':
          if (statoTrasferta === '0' || statoTrasferta === '1' || statoTrasferta === '3' || statoTrasferta === '4' || statoTrasferta === '6') {
            return true
          } else {
            return false
          }
      }
      return false
    },
    getStatoIcon_dett: function (stato) {
      switch (stato) {
        case '0':
        case '1':
        case '2':
        case '3':
        case '4':
          return 'riv-circle'
        default:
          return ''
      }
    },
    getStatoClass_dett: function (stato) {
      switch (stato) {
        case '0':
          return 'status-saved'
        case '1':
          return 'status-send'
        case '2':
          return 'status-rejected'
        case '3':
          return 'status-approved'
        case '4':
          return 'status-send'
        default:
          return ''
      }
    },
    openModal: function (field) {
      this.$set(this, field, true)
      this.$set(this, 'showPrincipal', false)
      this.$emit('showModalComponent', false)
    },
    closeModal: function (field) {
      this.$set(this, field, false)
      this.$set(this, 'showPrincipal', true)
      this.$emit('showModalComponent', true)
    }
  }
}
</script>

<style lang="less">
@import "../../assets/less/general.less";
@import "../../assets/less/mobile_customize.less";
@import "../../assets/less/el-table_mobile.less";
@import "../../assets/less/el-form_mobile.less";

.biglietti-mobile {
  // height: 100%;
  //min-width: 1250px;
  margin-bottom: 70px;
  max-width: 100%;

  .biglietti-header {
    height: 40px;
    margin-top: 10px;
    margin-bottom: 10px;

    .titolo {
      .set-font(@size: 16px, @color: @greenRiva, @family: "os-bold");
      text-align: left;
      line-height: 40px;
    }

    .action {
      text-align: right;
      line-height: 40px;

      .add {
        // position: fixed;
        // right: 20px;
        // bottom: 20px;
        float: right;
        color: #FF791A;
        margin-right: 10px;
        margin-left: 10px;
      }

      .send {
        // position: fixed;
        // right: 20px;
        // bottom: 20px;
        float: right;
        color: #FF791A;
        margin-right: 10px;
        margin-left: 10px;
      }
    }
  }

  .el-checkbox {
    margin-bottom: 0px;
    margin-top: 10px;

    .el-checkbox__inner {
      border-radius: 0px;
    }

    &.is-checked {
      .el-checkbox__inner {
        background-color: @greenRiva;
        border-color: @greenRiva;
      }
    }
  }

  /*.el-form_mobile {
      margin-bottom: 60px;
    }*/

  .popover-mobile {
    line-height: 50px;
    .set-font(@size: 18px, @color: @grayTesto, @family: "os-semibold")
  }

  .row {
    &.row-error {
      .el-form-label {
        color: red !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TrasferteMobile/BigliettiMobile.vue